import {typeExport} from "../../../../../redux/store/type";


const reducerAddTaskOperationSatiaScreen = (state = {
  empty: false,
    failed: false,
    lazyload_end: false,
    NoInternetDialog: false, page:1,
    results: [],
    isLoading: false,
    showRefresh: false,

    isLoadingSet: false,
    NoInternetDialogSet: false,
    resultsSet: null,
    notif: false,
    id: 0,
    ListFilter: []
}, action) => {
    const newState = {...state};
    switch (action.type) {
        case typeExport.AddTaskOperationSatiaScreen_SERVICE_PENDING:
            return {
                ...state,
                NoInternetDialog: false,
                isLoading: true,
                showRefresh: false,
                failed: false,
                empty: false,
                lazyload_end: false,

            };
        case typeExport.AddTaskOperationSatiaScreen_SERVICE_ERROR:
            return {
                ...state,
                NoInternetDialog:  true ,
                isLoading: false,
                showRefresh: false,
                failed:  true,
                lazyload_end: true,
                empty: false,
                page: action.page
            };
        case typeExport.AddTaskOperationSatiaScreen_SERVICE_SUCCESS:
            return {
                ...state,
                allResult: action.allResult,
                results:  action.results ,
                NoInternetDialog: false,
                isLoading: false,
                showRefresh: false,
                failed: false,
                lazyload_end: false,
                empty: false,
                page: action.page
            };
        case typeExport.AddTaskOperationSatiaScreen_SERVICE_END:
            return {
                ...state,
                allResult: action.allResult,
                //results: state.results,
                results: action.results ,
                NoInternetDialog: false,
                isLoading: false,
                showRefresh: false,
                failed: false,
                lazyload_end: true,
                empty: false,
                page: action.page
            };
        case typeExport.AddTaskOperationSatiaScreen_SERVICE_REFRESH:
            return {
                ...state,
                results: [],
                NoInternetDialog: false,
                isLoading: false,
                showRefresh: false,
                failed: false,
                lazyload_end: false,
                empty: false,
                page: action.page,
                id: 0,
                resultsSet: [],
                NoInternetDialogSet: false,
                isLoadingSet: false,
                //  ListFilter: [],

            };
        case typeExport.AddTaskOperationSatiaScreen_SERVICE_Empty:
            return {
                ...state,
                allResult: action.allResult,

                results: state.results,
                NoInternetDialog: false,
                isLoading: false,
                showRefresh: false,
                failed: false,
                lazyload_end: true,
                empty: true,
                page: action.page
            };
        case typeExport.AddTaskOperationSatiaScreen_SERVICE_ADD_FIRST_DATA:
            return {
                ...state,
                results: action.results,
                NoInternetDialog: false,
                showRefresh: false,
                failed: false,
                lazyload_end: action.lazyload_end,
                isLoading: action.isLoading,
                empty: action.empty,
                page: action.page
            };
        case typeExport.SetAddTaskOperationSatiaScreen_SERVICE_PENDING:
            return {
                ...state,
                NoInternetDialogSet: action.NoInternetDialogSet,
                isLoadingSet: action.isLoadingSet,
                resultsSet: action.resultsSet,
                id: action.id
            };
        case typeExport.SetAddTaskOperationSatiaScreen_SERVICE_ERROR:
            return {
                ...state,
                NoInternetDialogSet: action.NoInternetDialogSet,
                isLoadingSet: action.isLoadingSet,
                error: action.error
            };


        case typeExport.SetAddTaskOperationSatiaScreen_SERVICE_SUCCESS:

            newState.NoInternetDialogSet = action.NoInternetDialogSet;
            newState.resultsSet = action.resultsSet;
            newState.isLoadingSet = action.isLoadingSet;
            newState.id = 0;
            newState.results =
                newState.results.map((val, key) => {
                    if (val.id === action.id) {
                        val.apply_notify = action.resultsSet.apply_notify;
                        return val;
                    }
                    return val;
                });

            return newState

        case typeExport.AddTaskOperationSatiaScreen_SERVICE_CHANGE_NOTIF:


            newState.results =
                newState.results.map((val, key) => {
                    if (key === action.index) {
                        val.status = action.data;
                        return val;
                    }
                    return val;
                })

            return newState;
        case typeExport.AddTaskOperationSatiaScreen_SERVICE_AddSubList:

            return {
                ...state,
                results: action.data,
                isLoading: false,
                lazyload_end: (action.data.length < 10) ? true : false,
            };

        case typeExport.AddTaskOperationSatiaScreen_SERVICE_LIST_FILTER:

            return {
                ...state,
                ListFilter: action.ListFilter,

            };


        default:
            return state;
    }
}

export default reducerAddTaskOperationSatiaScreen;
